module.exports = __webpack_public_path__ + "static/media/honda.8a89602f.png";